import { render, staticRenderFns } from "./select.vue?vue&type=template&id=154d2025&scoped=true&"
import script from "./select.vue?vue&type=script&lang=ts&"
export * from "./select.vue?vue&type=script&lang=ts&"
import style0 from "./select.vue?vue&type=style&index=0&id=154d2025&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d2025",
  null
  
)

export default component.exports